import { render, staticRenderFns } from "./ApprovalRecord.vue?vue&type=template&id=224b786b&scoped=true&"
import script from "./ApprovalRecord.vue?vue&type=script&lang=js&"
export * from "./ApprovalRecord.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalRecord.vue?vue&type=style&index=0&id=224b786b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b786b",
  null
  
)

export default component.exports